import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import Emitter from 'Emitter';
import { renderBizMigrationDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog.helpers';
import { Space as ReactSpace } from 'reactApp/ui/Space/Space';

class Space extends Emitter {
    render() {
        const spaceEl = document.getElementById('space');

        if (!spaceEl) {
            return;
        }

        const reactSpace = new BReactComponent({
            ReactComponent: ReactSpace,
            renderMode: 'append',
        });

        reactSpace.renderTo(spaceEl, {
            props: {
                showBizMigration: renderBizMigrationDialog,
            },
        });
    }
}

const space = new Space();

export default () => {
    const render = () => {
        app.off('page:start', render);

        if (!app.isPublic()) {
            space.render();
            space.emit('render');
        }
    };

    app.on('page:start', render);
};

export { space };
